import { render, staticRenderFns } from "./saleQty.vue?vue&type=template&id=b2b72612&scoped=true"
import script from "./saleQty.vue?vue&type=script&lang=ts"
export * from "./saleQty.vue?vue&type=script&lang=ts"
import style0 from "./saleQty.vue?vue&type=style&index=0&id=b2b72612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b72612",
  null
  
)

export default component.exports